import humanizeString from 'humanize-string';

const CASE_CORRECTIONS_MAP = Object.assign(
  {},
  ...[
    'ASN',
    'BugTraq',
    'CERT',
    'CVE',
    'CVSS',
    'DCE',
    'DGA',
    'DHCP',
    'DNS',
    'FQDN',
    'FTP',
    'GUID',
    'HTTP',
    'HTTPS',
    'ID',
    'IDs',
    'IMPHASH',
    'IP',
    'IPv4',
    'IRC',
    'ISP',
    'MAC',
    'MD5',
    'NTLM',
    'OS',
    'PEHASH',
    'PID',
    'QClass',
    'RFB',
    'RPC',
    'RTT',
    'SHA1',
    'SHA256',
    'SSDEEP',
    'SIP',
    'SMTP',
    'SNMP',
    'SOCKS',
    'SSH',
    'SSL',
    'TCP',
    'TLD',
    'TLS',
    'TTL',
    'TZ',
    'UID',
    'UIDs',
    'URI',
    'URL',
  ].map((titleCase) => ({ [titleCase.toUpperCase()]: titleCase }))
);

/**
 * Humanize the input string with case corrections of industry standard words.
 */
export function humanizeToCorrectTitleCase(str: string) {
  return humanizeString(str)
    .split(' ')
    .map(
      (word) =>
        CASE_CORRECTIONS_MAP[word.toUpperCase()] ||
        word[0].toUpperCase() + word.slice(1)
    )
    .join(' ');
}
export function humanizeToCorrectLowerCase(str: string) {
  return humanizeString(str)
    .split(' ')
    .map(
      (word) =>
        CASE_CORRECTIONS_MAP[word.toUpperCase()] ||
        word[0].toLowerCase() + word.slice(1)
    )
    .join(' ');
}
